import { useEffect, useState } from 'react';
import { b64ToBlob } from '../util/b64ToBlob';
import axios from 'axios';
import { ENDPOINT_IMGBB } from '../constants';

export function useImageUpload(): [string | null, boolean, (value: any) => void, () => void] {
  const [imgPublicUrl, setImgPublicUrl] = useState<string | null>(null);
  const [errorUpload, setErrorUpload] = useState(false);
  const [imageBase64, setImageBase64] = useState<string | null>(null);
  const [source, setSource] = useState<any>(null);

  const handleCancelUpload = () => {
    source?.cancel();
  };

  useEffect(() => {
    if (!imageBase64) {
      setImgPublicUrl(null);
      return;
    }
    const CancelToken = axios.CancelToken;
    const sourceCancel = CancelToken.source();
    setSource(sourceCancel);

    // Divide el contenido del string Base64 en sus datos y el tipo de contenido
    const block = imageBase64.split(';');
    // Obtiene el tipo de contenido de la imagen
    const contentType = block[0].split(':')[1]; // In this case "image/gif"
    // Obtiene la información de la imagen
    const realData = block[1].split(',')[1];
    // Genera un nuevo archivo de tipo Blob a partir del Base64
    const file = b64ToBlob(realData, contentType);
    // Agrega el archivo dentro del formulario de datos
    const data = new FormData();
    data.append('image', file);

    const config = {
      headers: { 'Content-Type': 'multipart/form-data' },
      cancelToken: sourceCancel.token,
    };
    axios
      .post(ENDPOINT_IMGBB, data, config)
      .then((response) => {
        const { url } = response.data?.data;
        if (url) {
          setImgPublicUrl(url);
        } else {
          setErrorUpload(true);
        }
      })
      .catch(() => setErrorUpload(true));
  }, [imageBase64]);

  return [imgPublicUrl, errorUpload, setImageBase64, handleCancelUpload];
}
